module.exports = {
  app_version: "v1.2.2",
  api_development_url: "https://iotdata.blink-srl.com:8455/v1/",
  api_testing_url: "https://iotdata.blink-srl.com:8455/v1/",
  api_production_url: "https://iotdata.blink-srl.com:8455/v1/",
};

// api_development_url: "http://209.126.120.191:7692/v1/",
